import { env } from '@saucelabs/sl-util-config';

import { LOCAL_STORAGE_DEVICES } from './constants';

export const getTopLevelDomain = () => {
  if (env === 'production') {
    return '.saucelabs.com';
  }

  //  TODO:update the domain to .com after GKE migration
  if (env === 'staging') {
    return '.saucelabs.net';
  }

  return window.location.hostname;
};

export const parseJSON = (stringifiedJSON) => {
  try {
    return JSON.parse(stringifiedJSON);
  } catch (error) {
    return {};
  }
};

export const setDevicesInLocalStorage = (devices) => {
  const time = new Date();
  time.setSeconds(time.getSeconds() + 30);

  localStorage.setItem(LOCAL_STORAGE_DEVICES, JSON.stringify({
    devices,
    expiresAt: time,
  }));
};

export const getLocalStorageDevices = () => {
  const localStorageDevices = parseJSON(localStorage.getItem(LOCAL_STORAGE_DEVICES));

  if (localStorageDevices && Date.parse(localStorageDevices.expiresAt) >= new Date()) {
    return localStorageDevices.devices;
  }

  localStorage.removeItem(LOCAL_STORAGE_DEVICES);
  return null;
};
